var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"top-menu"},_vm._l((_vm.menuList),function(item){return _c('li',{key:item.id,class:{ 'active': _vm.currentId == item.id },on:{"click":function($event){return _vm.changeUrl(item)}}},[_vm._v("\n        "+_vm._s(item.name))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-d71e8f6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Menu.vue
// module id = null
// module chunks = 